declare global {
  interface Window {
    plausible?: (
      event: string,
      options?: { props?: Record<string, string | number | boolean> },
    ) => void;
  }
}

export function track(
  event: string,
  props?: Record<string, string | number | boolean>,
) {
  try {
    window.plausible?.(event, props ? { props } : undefined);
  } catch {
    // no-op
  }
}
